<template>
    <div>
        <div id="accordion" v-if="contractDetails.contractVersions.length >0">
            <div class="card najiz-card-panel mb-3">
                <div class="card-header najiz-panel-header" id="versions-heading">
                    <a class="text-dark" data-toggle="collapse" href="#versions-collapse" role="button" aria-expanded="false"
                       aria-controls="versions-collapse">
                        <h4 class="mb-0 py-3">
                            <i class="fal fa-angle-up rotate-icon fa-lg ml-5"></i>
                            <b>
                                النسخ السابقة للعقد
                            </b>
                        </h4>
                    </a>
                </div>

                <div id="versions-collapse" class="collapse show" aria-labelledby="versions-heading" data-parent="#accordion">
                    <div class="card-body">

                        <table class="table table-striped">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" scope="col">رقم نسخة العقد</th>
                                    <th class="text-center" scope="col">تاريخ نسخة العقد</th>
                                    <th v-if="contractDetails.isNajizRequest" class="text-center" scope="col">تحميل نسخة العقد</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!--{{ item.createdDate }}-->
                                <tr v-for="(item, masterIndex) in contractDetails.contractVersions" :key="masterIndex">
                                    <td class="text-center">{{ item.contractVersion }}</td>
                                    <td class="text-center">
                                        {{ item.createdDate | formatGregToHijri }} هـ -
                                        {{ item.createdDate | getFormattedDate }}م
                                    </td>
                                    <td v-if="contractDetails.isNajizRequest" class="text-center">
                                        <button class="btn btn-outline-primary mx-4 px-4"
                                                @click="downloadContractVersion(item)">
                                            <i class="fal fa-sign-in fa-rotate-90"></i>
                                        </button>
                                    </td>
                                </tr>

                            </tbody>
                        </table>




                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import { Inject } from 'vue-di-container';

    import { ContractDetails } from '@/models/contractDetailsModel';
    import ContractService from '@/services/contract.service';
    import { ContractStatusEnum } from '@/enums/contract-status.enum';
    import { ContractVersionModel } from '@/models/contractVersionModel';

    @Component({
        diProvide: [
            ContractService,
        ],
    })
    export default class ContractVersionsComponent extends Vue {
        @Prop({ required: true }) contractDetails!: ContractDetails;
        @Inject(ContractService) public contractService!: ContractService;
        /** The contract status enum. */
        contractStatusEnum = ContractStatusEnum;

        downloadContractVersion(item: ContractVersionModel) {
            const contractCode = this.contractDetails.contractCode as number;
            const partnerSocialId = this.contractDetails?.partners[0].socialId;
            this.contractService.getContractAsPDF(contractCode, partnerSocialId, item?.contractVersion).then((res) => {
                const linkSource = `data:application/pdf;base64,${res.model}`;
                const downloadLink = document.createElement('a');
                const fileName = `${contractCode}V${item?.contractVersion}.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
        }
    }
</script>
